import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthLayout } from '../../components/AuthLayout.js';
import { readApiError } from '../../lib/apiError.js';

export default function PasswordResetPage(): JSX.Element {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (res.ok) {
        setSuccess(true);
      } else {
        setError((await readApiError(res, 'Request failed')).message);
      }
    } catch (err: unknown) {
      console.error(err);
      setError('Network error');
    }
  };

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="We will email you a link to choose a new password."
    >
      {error && <div className="auth-error">{error}</div>}
      {success && (
        <div className="auth-success">If an account exists, a reset link has been sent.</div>
      )}
      <form onSubmit={handleSubmit} className="auth-form">
        <div className="field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            className="input"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
        </div>
        <button type="submit" className="btn btn-primary">
          Send reset link
        </button>
      </form>

      <div className="auth-links">
        <Link to="/login">Back to sign in</Link>
      </div>
    </AuthLayout>
  );
}
